
import React, { useState, useEffect } from 'react';

const SEVERITY_STYLES = {
  success: 'bg-green-600',
  error: 'bg-red-600',
  info: 'bg-blue-600',
  warning: 'bg-yellow-500',
};

const Notifier = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handleNotify = (event) => {
      if (!event.detail) return;
      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, ...event.detail }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 4000);
    };

    window.addEventListener('notify', handleNotify);
    return () => window.removeEventListener('notify', handleNotify);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`${SEVERITY_STYLES[t.severity] || SEVERITY_STYLES.info} text-white px-4 py-3 rounded-lg shadow-lg min-w-[280px] animate-fade-in`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
};

export default Notifier;

const dispatch = (message, severity) => {
  window.dispatchEvent(new CustomEvent('notify', { detail: { message, severity } }));
};

export const toast = {
  success: (message) => dispatch(message, 'success'),
  error: (message) => dispatch(message, 'error'),
  info: (message) => dispatch(message, 'info'),
  warning: (message) => dispatch(message, 'warning'),
};